import { IPagination } from 'app/types/common';

export interface IReceiptsState {
  readonly receiptsById?: any;
  readonly receiptIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectReceiptLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddReceipt?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationReceiptIds?: string[];
  readonly currentReceiptId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IReceiptsSelector extends IReceiptsState {
  readonly currentReceipt?: any;
  readonly currentFormReceipt?: any;
  readonly getReceiptsFilteredByTagInSelectFormat?: any;
  readonly receiptsByIdInSelectFormat?: any;
}

export enum ReceiptsActionTypes {
  GET_ALL_RECEIPTS_REQUESTED = 'redux-app/receipts/GET_ALL_RECEIPTS_REQUESTED',
  GET_ALL_RECEIPTS_PENDING = 'redux-app/receipts/GET_ALL_RECEIPTS_PENDING',
  GET_ALL_RECEIPTS_SUCCESS = 'redux-app/receipts/GET_ALL_RECEIPTS_SUCCESS',
  GET_ALL_RECEIPTS_FAIL = 'redux-app/receipts/GET_ALL_RECEIPTS_FAIL',
  GET_RECEIPT_REQUESTED = 'redux-app/receipts/GET_RECEIPT_REQUESTED',
  GET_RECEIPT_PENDING = 'redux-app/receipts/GET_RECEIPT_PENDING',
  GET_RECEIPT_SUCCESS = 'redux-app/receipts/GET_RECEIPT_SUCCESS',
  GET_RECEIPT_FAIL = 'redux-app/receipts/GET_RECEIPT_FAIL',
  UPDATE_RECEIPT_REQUESTED = 'redux-app/receipts/UPDATE_RECEIPT_REQUESTED',
  UPDATE_RECEIPT_PENDING = 'redux-app/receipts/UPDATE_RECEIPT_PENDING',
  UPDATE_RECEIPT_SUCCESS = 'redux-app/receipts/UPDATE_RECEIPT_SUCCESS',
  UPDATE_RECEIPT_FAIL = 'redux-app/receipts/UPDATE_RECEIPT_FAIL',
  CREATE_RECEIPT_REQUESTED = 'redux-app/receipts/CREATE_RECEIPT_REQUESTED',
  CREATE_RECEIPT_PENDING = 'redux-app/receipts/CREATE_RECEIPT_PENDING',
  CREATE_RECEIPT_SUCCESS = 'redux-app/receipts/CREATE_RECEIPT_SUCCESS',
  CREATE_RECEIPT_FAIL = 'redux-app/receipts/CREATE_RECEIPT_FAIL',
  DELETE_RECEIPT_REQUESTED = 'redux-app/receipts/DELETE_RECEIPT_REQUESTED',
  DELETE_RECEIPT_PENDING = 'redux-app/receipts/DELETE_RECEIPT_PENDING',
  DELETE_RECEIPT_SUCCESS = 'redux-app/receipts/DELETE_RECEIPT_SUCCESS',
  DELETE_RECEIPT_FAIL = 'redux-app/receipts/DELETE_RECEIPT_FAIL',
  SELECT_RECEIPT_REQUESTED = 'redux-app/receipts/SELECT_RECEIPT_REQUESTED',
}

export default null;
